import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from '../finance/shared';

const DayOfWeekCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    if (!date) return;
    const selectedDate = new Date(date);
    if (isNaN(selectedDate.getTime())) return;

    const daysOfWeek = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
    const dayName = daysOfWeek[selectedDate.getDay()];

    const getZodiacSign = (d: Date) => {
      const m = d.getMonth() + 1, dy = d.getDate();
      if ((m === 3 && dy >= 21) || (m === 4 && dy <= 19)) return 'Áries';
      if ((m === 4 && dy >= 20) || (m === 5 && dy <= 20)) return 'Touro';
      if ((m === 5 && dy >= 21) || (m === 6 && dy <= 20)) return 'Gêmeos';
      if ((m === 6 && dy >= 21) || (m === 7 && dy <= 22)) return 'Câncer';
      if ((m === 7 && dy >= 23) || (m === 8 && dy <= 22)) return 'Leão';
      if ((m === 8 && dy >= 23) || (m === 9 && dy <= 22)) return 'Virgem';
      if ((m === 9 && dy >= 23) || (m === 10 && dy <= 22)) return 'Libra';
      if ((m === 10 && dy >= 23) || (m === 11 && dy <= 21)) return 'Escorpião';
      if ((m === 11 && dy >= 22) || (m === 12 && dy <= 21)) return 'Sagitário';
      if ((m === 12 && dy >= 22) || (m === 1 && dy <= 19)) return 'Capricórnio';
      if ((m === 1 && dy >= 20) || (m === 2 && dy <= 18)) return 'Aquário';
      return 'Peixes';
    };

    const res = { dayName, zodiacSign: getZodiacSign(selectedDate) };
    setResultState(res);
    onResultChange([
      { label: 'Dia', value: res.dayName },
      { label: 'Data', value: selectedDate.toLocaleDateString('pt-BR') },
      { label: 'Signo', value: res.zodiacSign }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <FormField label="Data" value={date} onChange={setDate} type="date" required />
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all flex items-center gap-2">
            <Icon name="play" className="w-5 h-5" /> Calcular
          </button>
        </div>
        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <ResultCard title="Dia" value={resultState.dayName} color="indigo" />
            <ResultCard title="Signo" value={resultState.zodiacSign} color="purple" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DayOfWeekCalculator;
